import { useEffect, useCallback } from 'react';
import { useRefreshTokenMutation } from '../api/authApi';
import { getRefreshToken, setAccessToken, setRefreshToken, removeAccessToken, removeRefreshToken } from '../../../app/utils/authStorage';
import { redirectToAuthLanding } from '../../../app/components/auth/authModalStorage';

export const useTokenRefresh = () => {
    const [refreshTokenMutation] = useRefreshTokenMutation();

    const refreshToken = useCallback(async () => {
        try {
            const refreshToken = getRefreshToken();
            if (refreshToken) {
                const result = await refreshTokenMutation({ refreshToken }).unwrap();
                setAccessToken(result.access_token);
                setRefreshToken(result.refresh_token);
                return true;
            }
        } catch (error) {
            console.error('Token refresh failed:', error);
            removeAccessToken();
            removeRefreshToken();
            // Для Telegram Mini App не делаем редирект - позволяем useUser/AuthGuard обработать автологин
            // Для веб-версии редиректим на страницу авторизации
            if (!window.Telegram?.WebApp?.initData && !window.location.search.includes('auth=')) {
                redirectToAuthLanding('login');
            }
        }
        return false;
    }, [refreshTokenMutation]);

    useEffect(() => {
        const interval = setInterval(refreshToken, 10 * 60 * 1000);
        return () => clearInterval(interval);
    }, [refreshToken]);

    return { refreshToken };
};
